export const getCompanyId = () => {
    const companyId = JSON.parse(localStorage.getItem("companyIdLs"))
    if (companyId) {
        return companyId
    } else {
        return null
    }
}